class PWAApp {
    constructor(elements, reload) {
        this.elements = elements;
        this.reload = reload;
        this.isPwa = window.matchMedia("(display-mode: standalone)").matches;
        this.init();
    }

    init() {
        if (this.isPwa) {
            // Replace home page links with the app homepage
            const homeLinks = document.querySelectorAll('[href="/"]');
            homeLinks.forEach((el) => {
                el.setAttribute("href", "/app/");
            });
        }

        this.setActiveNavItem();
        this.initInstallBanner();

        if (this.isPwa || document.body.classList.contains("app-homepage")) {
            this.toggleSections();
        }
    }

    setActiveNavItem() {
        const navItems = document.querySelectorAll(".app-bottom-nav__item");
        const path = window.location.pathname;
        navItems.forEach((item) => {
            const navPath = item.dataset.navPath;
            if (navPath === path || (navPath !== "/app/" && path.startsWith(navPath))) {
                item.classList.add("is-active");
            }
        });
    }

    initInstallBanner() {
        if (this.isPwa) return;
        if (localStorage.getItem("app-install-banner-dismissed")) return;

        const banner = document.getElementById("app-install-banner");
        if (!banner) return;

        banner.classList.remove("hidden");
        banner.classList.add("is-visible");

        const dismissBtn = document.getElementById("app-install-banner-dismiss");
        if (dismissBtn) {
            dismissBtn.addEventListener("click", () => {
                banner.classList.remove("is-visible");
                banner.classList.add("hidden");
                localStorage.setItem("app-install-banner-dismissed", "1");
            });
        }
    }

    toggleSections() {
        const sections = document.querySelectorAll("[data-show-if]");
        if (sections.length !== 0) {
            fetch("/accounts/status/app/", { credentials: "same-origin" })
                .then((res) => res.json())
                .then((data) => {
                    let tags = [];
                    if (data["is_volunteer"]) {
                        tags.push("volunteer");
                    }
                    if (data["running_events"]) {
                        tags.push("running_events");
                    }
                    // PWA/progressier disabled for now — re-enable by uncommenting.
                    // progressier.add({
                    //     id: data["user_id"],
                    //     tags: tags,
                    // });
                    sections.forEach((section) => {
                        if (data[section.dataset.showIf]) {
                            section.classList.remove("hidden");
                        } else {
                            section.classList.add("hidden");
                        }
                    });
                });
        }
    }
}

export default PWAApp;
